import Vue from 'vue'
import Router from 'vue-router'
import menuModule from 'vuex-store/modules/menu'

import Scenario from '../views/scenarios/Scenario'

Vue.use(Router)

export default new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'is-active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      name: 'Рассылки',
      path: '/campaigns',
      component: require('../views/campaigns/Campaigns')
    },
    {
      name: 'Архив рассылок',
      path: '/archive',
      component: require('../views/campaigns/Archive')
    },
    {
      name: 'Новая рассылка',
      path: '/campaigns/new',
      component: require('../views/campaigns/Campaign')
    },
    {
      name: 'Копия рассылки',
      path: '/campaigns/copy/:idcopy',
      component: require('../views/campaigns/Campaign'),
      props: true
    },
    {
      name: 'Рассылка',
      path: '/campaigns/:id',
      component: require('../views/campaigns/Campaign'),
      props: true
    },
    {
      name: 'Сценарии',
      path: '/scenarios',
      component: require('../views/scenarios/Scenarios')
    },
    {
      path: '/scenarios/:campaignid/new',
      component: Scenario,
      name: 'Новый сценарий',
      props: true
    },
    {
      name: 'Сценарий',
      path: '/scenarios/:campaignid/:id',
      component: require('../views/scenarios/Scenario'),
      props: true
    },
    {
      name: 'Пользователи',
      path: '/users',
      component: require('../views/users/Users')
    },
    {
      name: 'Пользователь',
      path: '/users/:id',
      component: require('../views/users/User'),
      props: true
    },
    {
      name: 'Новый пользователь',
      path: '/users/new',
      component: require('../views/users/User')
    },
    {
      name: 'Данные пользователя',
      path: '/profiles/:id',
      component: require('../views/profiles/Profile'),
      props: true
    },
    {
      name: 'Клиенты',
      path: '/clients',
      component: require('../views/clientes/Clientes')
    },
    {
      name: 'Параметры клиента',
      path: '/users/client/:id',
      component: require('../views/clientes/ClientParameters'),
      props: true
    },
    {
      name: 'Номера на прозвон',
      path: '/callTasks/:id',
      component: require('../views/calltasks/CalltasksCampaign'),
      props: true
    },
    {
      name: 'Мониторинг рассылки',
      path: '/monitoring/:id',
      component: require('../views/campaigns/CampaignMonitoring'),
      props: true
    },
    {
      name: 'Тестовые номера',
      path: '/callTasksTest/:id',
      component: require('../views/calltasks/TestCalltasksCampaign'),
      props: true
    },
    {
      name: 'Результат теста',
      path: '/callTasksTestResult/:campaignid/:id',
      component: require('../views/calltasks/TestCallTasksResult'),
      props: true
    },
    {
      name: 'Лицевой счет клиента',
      path: '/billing/client/:id',
      component: require('../views/billing/Billing'),
      props: true
    },
    {
      name: 'Авторизация',
      path: '/login',
      component: require('../views/authentication/Login')
    },
    {
      name: 'Регистрация',
      path: '/sign-up',
      component: require('../views/authentication/SignUp')
    },
    {
      name: 'Настройка прав',
      path: '/permissions',
      component: require('../views/settings/Permissions')
    },
    {
      name: 'Настройка приложения',
      path: '/appconfig',
      component: require('../views/settings/AppConfig')
    },
    ...generateRoutesFromMenu(menuModule.state.items),
    {
      path: '*',
      redirect: '/campaigns'
    }

  ]
})
// Menu should have 2 levels.
function generateRoutesFromMenu (menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path) {
      routes.push(item)
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes)
    }
  }
  return routes
}



// WEBPACK FOOTER //
// ./client/router/index.js